
<div class="calendar-map" id="map-auto-height">
  <div class="row no-gutters">
    <div class="col-7 o-hidden">
      @if (minHeight !== null) {
        @if (data == null) {
          <div class="calendar-map__loader">
            <i class="fa fa-spin fa-spinner"></i> загрузка данных
          </div>
        }
        @if (data && data['complexes']) {
          <osm-map
            [center]="[55.76, 37.64]"
            [zoom]="11"
            [style]="{'height': minHeight + 'px'}">
            @for (c of data['complexes']; track c) {
              <osm-placemark
                [coordinates]="[c['housing_lat'], c['housing_lon']]"
                [balloonContent]="content"
                [options]="{'caption': c['housing_caption']}">
                <td class="" #content>
                  @if (c.housing_caption) {
                    <div class="">
                      <span class="font-weight-bold">{{c.housing_caption}}</span>
                    </div>
                  }
                  @if (c.developer) {
                    <div class="">
                      <span class="text-muted">Застройщик:</span> {{c.developer}}
                    </div>
                  }
                  @if (c.housing_address) {
                    <div class="">
                      <span class="text-muted">Адрес:</span> {{c.housing_address}}
                    </div>
                  }
                  @if (c.subway) {
                    <div>
                      <span class="text-muted">Метро:</span> {{c.subway}}
                    </div>
                  }
                  @if (c.housing_class_caption) {
                    <div class="">
                      <span class="text-muted">Класс:</span> {{c.housing_class_caption}}
                    </div>
                  }
                  @if (c.housing_date) {
                    <div class="">
                      <span class="text-muted">Дата сдачи:</span>{{c.housing_date}}
                    </div>
                  }
                  <div class="mt-2">
                    <table style="width: 100%">
                      @if (c['1_room_area']) {
                        <tr>
                          <td>1-комнатные</td>
                          <td>от {{c['1_room_area']}} м<sup><small>2</small></sup></td>
                          <td>
                            <span [outerHTML]="c['1_room_price'] | priceRank"></span>
                          </td>
                        </tr>
                      }
                      @if (c['2_room_area']) {
                        <tr>
                          <td>2-комнатные</td>
                          <td>от {{c['2_room_area']}} м<sup><small>2</small></sup></td>
                          <td>
                            <span [outerHTML]="c['2_room_price'] | priceRank"></span>
                          </td>
                        </tr>
                      }
                      @if (c['3_room_area']) {
                        <tr>
                          <td>3-комнатные</td>
                          <td>от {{c['3_room_area']}} м<sup><small>2</small></sup></td>
                          <td>
                            <span [outerHTML]="c['3_room_price'] | priceRank"></span>
                          </td>
                        </tr>
                      }
                      @if (c['4_room_area']) {
                        <tr>
                          <td>4-комнатные</td>
                          <td>от {{c['4_room_area']}} м<sup><small>2</small></sup></td>
                          <td>
                            <span [outerHTML]="c['4_room_price'] | priceRank"></span>
                          </td>
                        </tr>
                      }
                      @if (c['studios_area']) {
                        <tr>
                          <td>Студии</td>
                          <td>от {{c['studios_area']}} м<sup><small>2</small></sup></td>
                          <td class="col-auto text-right">
                            <span [outerHTML]="c['studios_price'] | priceRank"></span>
                          </td>
                        </tr>
                      }
                    </table>
                  </div>
                </osm-placemark>
              }
              <!-- // -->
              @for (c of data['subagents']; track c) {
                <osm-placemark
                  [coordinates]="[c['lat'], c['lon']]"
                  [icon]="'blue'"
                  [balloonContent]="content"
                  [options]="{'caption': c['organisation_caption']}">
                  <div class="" #content>
                    <div class="mb-2 font-weight-bold">{{c['organisation_caption']}}</div>
                    @if (c.organisation_fact_address) {
                      <div>
                        <span class="text-muted">Адрес:</span> {{c.organisation_fact_address}}
                      </div>
                    }
                    @if (c.organisation_phone) {
                      <div>
                        <span class="text-muted">Телефон:</span> {{c.organisation_phone}}
                      </div>
                    }
                    @if (c.organisation_email) {
                      <div>
                        <span class="text-muted">Email:</span> {{c.organisation_email}}
                      </div>
                    }
                  </div>
                </osm-placemark>
              }
            </osm-map>
          }
        }
      </div>
      <div class="col-5 calendar-map__table" [ngStyle]="{'height': minHeight + 'px'}">
        <app-calendar-map-tables [realty_list]="realty_list"></app-calendar-map-tables>
      </div>
    </div>

  </div>
